import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  //@Input() public reasons: [];

  hasErrorReason: boolean = false;

  form = this.fb.group({
    cancelReasons: [null]

  });

  constructor(
    private dialogRef: MatDialogRef<ConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {

  }


  submit() {

    
    if (this.form.controls['cancelReasons'].value == null && this.data.cancelReasons?.length > 0) {
      this.hasErrorReason = true;
      return;
    }

    let resultChoose = {
      reasonId: this.form.controls['cancelReasons'].value,
      choose: true
    }

    this.dialogRef.close(resultChoose);
  }

  cancel() {

    let resultChoose = {
      reasonId: "",
      choose: false
    }
    this.dialogRef.close(resultChoose);
  }

}
